@let previousVisibleItem = previousItem?.dayOff ? null : previousItem;
@let nextVisibleItem = nextItem?.dayOff ? null : nextItem;
@let gapBefore = previousVisibleItem?.enddate | minutesDiff: item.begindate;
@let gapAfter = item.enddate | minutesDiff: nextVisibleItem?.begindate;

<div
    class="schedule-item"
    [class.dayoff]="item.dayOff || item.begindate > maxDate"
    [class.connect-next]="nextVisibleItem && !item.dayOff && gapAfter <= 120"
    [class.connect-prev]="previousVisibleItem && !item.dayOff && gapBefore <= 120"
    (click)="openItem.emit()">
    <div class="container wrapper">
        <div class="content">
            <ng-content />
            @if (leaveHourtype) {
                <div class="time">{{ item.begindate | date: 'HH:mm' }} - {{ item.enddate | date: 'HH:mm' }}</div>
                <div class="project">
                    <b>{{ leaveHourtype | hourtype }}</b>
                    @if (leaveComment) {
                        - {{ leaveComment }}
                    }
                </div>
            }
        </div>
        @if (!item.dayOff && item.begindate < maxDate) {
            <button mat-icon-button>
                <i class="fas fa-chevron-right"></i>
            </button>
        }
    </div>
</div>
